import { useCallback, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'velox_admin_theme';
const THEMES = /** @type {const} */ (['dark', 'light']);

function normalizeTheme(value) {
  if (value === 'light' || value === 'dark') return value;
  return 'dark'; // Admin default (per spec)
}

export function useAdminTheme() {
  const [theme, setTheme] = useState(() => normalizeTheme(localStorage.getItem(STORAGE_KEY)));

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      // best-effort persistence only
    }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  }, []);

  const isDark = theme === 'dark';

  const themeMeta = useMemo(() => ({
    theme,
    isDark,
    themes: THEMES
  }), [isDark, theme]);

  return { ...themeMeta, setTheme, toggleTheme };
}

